import React from 'react'
import PropTypes from 'prop-types'
import { Card, Tag, Timeline } from 'antd'
import { decisionEventColor, decisionOutcome, decisionQuestion } from '../decisions'

// Every car question this conversation asked and how it ended (spec:
// 0040_assistant_car_decisions Req 3). Oldest first, like the transcript it sits beside.
const DecisionLog = ({ entries }) => {
  if (!entries || !entries.length) return null
  return (
    <Card size="small" title="Decisions" style={{ marginBottom: 12 }}>
      <Timeline>
        {entries.map((entry, index) => (
          <Timeline.Item key={`${entry.at}-${index}`} color={decisionEventColor(entry.event)}>
            <Tag color={decisionEventColor(entry.event)}>{entry.event}</Tag>
            {entry.event === 'opened'
              ? decisionQuestion(entry.kind)
              : decisionOutcome(entry.event, entry.detail)}
            {entry.carLabel ? ` — ${entry.carLabel}` : ''}
            <div>
              <small style={{ opacity: 0.65 }}>
                {entry.at ? new Date(entry.at).toLocaleString() : ''}
              </small>
            </div>
          </Timeline.Item>
        ))}
      </Timeline>
    </Card>
  )
}

DecisionLog.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      at: PropTypes.string,
      event: PropTypes.string,
      kind: PropTypes.string,
      detail: PropTypes.string,
      carLabel: PropTypes.string
    })
  )
}

DecisionLog.defaultProps = { entries: [] }

export default DecisionLog
